// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._mYATaCcMK2ewW {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding: 4px var(--ds-space-0, 0) 8px;
}
.eJr1M5dvA2gEXh {
  display: flex;
  flex-grow: 1;
  align-items: center;
  min-width: 0;
  margin-bottom: 4px;
  gap: 4px;
}
.jbjVH3uLtIZCZ5 .eJr1M5dvA2gEXh {
  margin-bottom: var(--ds-space-0, 0px);
}
.rvGWDMgF3Sdu71 {
  flex-shrink: 0;
  margin-bottom: var(--ds-space-0, 0);
  padding: 8px;
}
.jbjVH3uLtIZCZ5 {
  box-sizing: border-box;
  width: 100%;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0) var(--ds-space-0, 0) 4px 4px;
  cursor: pointer;
}
.bMMW2vKvXZ60So {
  flex-grow: 1;
  min-width: 0;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin-left: 12px;
}
.RGfjJBm_f4cdMG.selected {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .RGfjJBm_f4cdMG.selected {
  outline-color: -webkit-focus-ring-color;
}
.RGfjJBm_f4cdMG.selected .mac.firefox {
  outline-color: AccentColor;
}
`, ""]);
// Exports
export var labelsList = `_mYATaCcMK2ewW`;
export var labelContainer = `eJr1M5dvA2gEXh`;
export var checkbox = `jbjVH3uLtIZCZ5`;
export var editButton = `rvGWDMgF3Sdu71`;
export var labelContent = `bMMW2vKvXZ60So`;
export var label = `RGfjJBm_f4cdMG`;
export default ___CSS_LOADER_EXPORT___;
